(function(){
    'use strict';

    angular.module('elogbooks.common.performance-statistics', []);
})();
